import { render, staticRenderFns } from "./SimpleNotification.vue?vue&type=template&id=3034c6f7&scoped=true&"
import script from "./SimpleNotification.vue?vue&type=script&lang=js&"
export * from "./SimpleNotification.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNotification.vue?vue&type=style&index=0&id=3034c6f7&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034c6f7",
  null
  
)

export default component.exports